// import { Exercise, ExerciseCreateRequest, ExerciseSearchRequest, User } from '@api/entities';
import { Store } from '@reduxjs/toolkit';
import { AuthApiService, IAuthApiService } from '../services/auth/auth.api.service';
import { ExerciseApiService, IExerciseApiService } from '../services/exercise/exercise.api.service';
import { Exercise, ExerciseCreateRequest } from 'src/api/entities';

export interface IExerciseManager {
    create(request: ExerciseCreateRequest): Promise<Exercise>;
    updateURL(uuid: string, url: string): Promise<Exercise>;
    search(authorID: number): Promise<Exercise[]>;
    edit(oldExercise: Exercise, updatedExercise: Exercise): Promise<Exercise>;
    fetchByUuid(uuid: string): Promise<Exercise>;
    delete(uuid: string): Promise<{ [key: string]: boolean }>;
}

export class ExerciseManager implements IExerciseManager {
    private static instance: ExerciseManager;
    private storeManager: Store;
    private exerciseService: IExerciseApiService;

    private constructor() {
        this.exerciseService = ExerciseApiService.getInstance(process.env.REACT_APP_MICROSERVICE_AUTH_BASEPATH!);
    }

    static getInstance() {
        if (ExerciseManager.instance == null) {
            ExerciseManager.instance = new ExerciseManager();
        }
        return ExerciseManager.instance;
    }
    async create(request: ExerciseCreateRequest): Promise<Exercise> {
        const response = await this.exerciseService.create(request);
        return response;
    }
    async updateURL(uuid: string, url: string): Promise<Exercise> {
        const response = await this.exerciseService.updateURL(uuid, url);
        return response;
    }
    async edit(oldExercise: Exercise, updatedExercise: Exercise): Promise<Exercise> {
        const response = await this.exerciseService.edit(oldExercise, updatedExercise);
        return response;
    }

    async fetchByUuid(uuid: string): Promise<Exercise> {
        const response = await this.exerciseService.getByUuid(uuid);
        return response;
    }

    async delete(uuid: string): Promise<{ [key: string]: boolean }> {
        const response = await this.exerciseService.delete(uuid);
        return response;
    }

    async search(authorID?: number, query?: string, group?: string): Promise<Exercise[]> {
        const response = await this.exerciseService.search({
            page: 0,
            size: 100,
            query: query,
            filter: {
                authorID: 0,
                group: group,
            },
        });
        return response;
    }
}
